import type { StatDefinition } from '../types';
import { creditField } from '../shared';

/**
 * NHL per-player stats. These mirror the original hardcoded attribution that
 * lived in shiftUtils — each is a simple event count credited to one
 * participant on a single event type.
 */
export const NHL_STATS: ReadonlyArray<StatDefinition> = [
  { key: 'goals', label: 'Goals', attribute: (e) => creditField(e, 'goal', 'shooter') },
  { key: 'assists', label: 'Assists', attribute: (e) => creditField(e, 'goal', 'assister') },
  { key: 'hits', label: 'Hits', attribute: (e) => creditField(e, 'hit', 'hitter') },
  { key: 'penalties', label: 'Penalties', attribute: (e) => creditField(e, 'penalty', 'committed') },
  {
    key: 'shotsOnGoal',
    label: 'SOG',
    fullName: 'Shots on Goal',
    attribute: (e) => creditField(e, 'shot_on_goal', 'shooter'),
  },
];
